import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  classList: PropTypes.string,
  /** If omitted, link will behave like a button */
  href: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  /** [Target attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) */
  target: PropTypes.string,
  theme: PropTypes.oneOf(['default', 'inverse'])
};
function Link(_ref) {
  var children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    onClick = _ref.onClick,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  return href ? /*#__PURE__*/React__default.createElement("a", {
    className: icon ? "icon-link ".concat(classList) : classList || null,
    "data-theme": theme,
    href: href,
    onClick: onClick,
    rel: target === '' ? null : 'noreferrer noopener',
    target: target === '' ? null : target
  }, icon, icon && children ? /*#__PURE__*/React__default.createElement("span", {
    className: "icon-link-text",
    "data-testid": "icon-link-text"
  }, children) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children)) : /*#__PURE__*/React__default.createElement("button", {
    className: "link-button ".concat(classList),
    "data-theme": theme,
    onClick: onClick,
    type: "button"
  }, children);
}
Link.propTypes = propTypes;
Link.displayName = 'Link';

export { Link as default };
//# sourceMappingURL=Link.js.map
